import type { ListItem } from '@/components/Accordion';
import { useTranslation } from '@/utils/useTranslation';
import HelpPageLayout from '@/components/HelpPageLayout';
import { useGlobalContext } from '../GlobalProvider';

const TermsConditions = () => {
  const { programmeId = 'BAEC' } = useGlobalContext();

  const { t } = useTranslation(`${programmeId}/terms-and-conditions`);

  const termsConditions = t<Array<ListItem>>('termsConditions', {
    returnObjects: true,
  });

  return (
    <HelpPageLayout
      title={t('title')}
      description={t('description')}
      linkText={t('linkText')}
      linkUrl={t('linkUrl')}
      list={termsConditions}
    />
  );
};

export default TermsConditions;
